"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Spinner["default"];
  }
});
Object.defineProperty(exports, "spinnerThemeNamespace", {
  enumerable: true,
  get: function get() {
    return _themes.spinnerThemeNamespace;
  }
});
Object.defineProperty(exports, "spinnerClassicTheme", {
  enumerable: true,
  get: function get() {
    return _themes.spinnerClassicTheme;
  }
});
Object.defineProperty(exports, "spinnerDarkTheme", {
  enumerable: true,
  get: function get() {
    return _themes.spinnerDarkTheme;
  }
});

var _Spinner = _interopRequireDefault(require("./Spinner"));

var _themes = require("./themes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}